import Icon from 'emerald-ui/lib/Icon';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Icon, componentName: 'Icon' }], 'Icon'),
  description: 'An Icon displays a Material Icons icon.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Icon },
      whiteBackground: true,
      code: `<Icon name="face" style={{ fontSize: '24px' }} className="text-danger" />`,
    },
  ],
};
